import { gql } from '@apollo/client'

export type GetCustomerBalancesResult = {
  customer: {
    laybyBalance: { amount: string } | null
    onAccountBalance: { amount: string } | null
  } | null
}

export const getCustomerBalancesQuery = gql`
  query GetCustomerBalances($customerId: ID!) {
    customer(id: $customerId) {
      laybyBalance {
        amount
      }
      onAccountBalance {
        amount
      }
    }
  }
`
